import React from 'react';
import { withCampaignProvider } from 'context/CampaignContext';
import Create from './Create';
import { GET_SINGLE_CAMPAIGN } from 'Queries';
import { useQuery } from '@apollo/react-hooks';
import { Spinner } from 'components';
import useReactRouter from 'use-react-router';

const Duplicate = ({ setIsOpen }) => {
	const { match } = useReactRouter();
	const { id } = match.params;
	const { data, loading, error } = useQuery(GET_SINGLE_CAMPAIGN, {
		variables: {
			id,
		},
		fetchPolicy: 'cache-first',
	});

	if (error) throw new Error(error);
	if (loading) return <Spinner />;

	let campaignData = null
	if(data.campaign){
		let {id:{campaignId}, name, ...other} = data.campaign
		campaignData = other
		campaignData.name = `${name} (copy)`
	}
	
	if (data) {
		const DuplicateCampaign = withCampaignProvider(Create, campaignData, true, setIsOpen); //duplication = true
		return <DuplicateCampaign />;
	}
};

export default Duplicate;
